import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UpdateUseOfProceedsModalUI from './UpdateUseOfProceedsModalUI.js'

class UpdateUseOfProceedsModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      vendorName: '',
      vendorNameError: null,
      itemDetails: '',
      itemDetailsError: null,
      amount: '',
      amountError: null
    }
  }

  render() {
    return (
      <UpdateUseOfProceedsModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        vendorName={this.state.vendorName}
        onVendorNameChange={(event) => { this.setState({ vendorName: event.target.value }) }}
        vendorNameError={this.state.vendorNameError}
        setVendorNameError={(error) => { this.setState({ vendorNameError: error }) }}
        //
        itemDetails={this.state.itemDetails}
        onItemDetailsChange={(event) => { this.setState({ itemDetails: event.target.value }) }}
        itemDetailsError={this.state.itemDetailsError}
        setItemDetailsError={(error) => { this.setState({ itemDetailsError: error }) }}
        //
        amount={this.state.amount}
        onAmountChange={(event) => { this.setState({ amount: event.target.value }) }}
        amountError={this.state.amountError}
        setAmountError={(error) => { this.setState({ amountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loan/${this.props.loan.loanId}/dsraSource/draftProceeds/${this.props.selectedProceedsId}`,
      this.onSubmitCallback,
      {
        vendorName: this.state.vendorName,
        itemDetails: this.state.itemDetails,
        amount: this.state.amount
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(UpdateUseOfProceedsModalSF)
